import {useQuery} from "@tanstack/react-query";
import {config} from "@/constants/config";
import {type GameLaunchResult, getGameLaunchService} from "./gameLaunch.service";

export const GAME_LAUNCH_QUERY_KEY = "game-launch" as const;

export interface UseGameLaunchParams {
  provider: string | undefined;
  gameId: string | undefined;
  currency?: string;
  isMobile?: boolean;
}

export const useGameLaunch = ({provider, gameId, currency, isMobile}: UseGameLaunchParams) => {
  const enabled = Boolean(provider && gameId);
  const resolvedCurrency = currency ?? config.defaultCurrency;

  const query = useQuery<GameLaunchResult, Error>({
    queryKey: [GAME_LAUNCH_QUERY_KEY, provider, gameId, resolvedCurrency, isMobile],
    queryFn: () =>
      getGameLaunchService({
        provider: provider as string,
        gameId: gameId as string,
        currency: resolvedCurrency,
        isMobile,
      }),
    enabled,
    staleTime: 30_000,
    retry: false,
  });

  return {
    gameUrl: query.data?.gameUrl ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
